import { useState } from 'react';

const faqs = [
  {
    q: 'How do I sign up for a PNGGO account?',
    a: 'Tap Join Now on PNGGO, complete the short registration form with accurate details, and verify your account when prompted. Use only official PNGGO links — never share your password or OTP with anyone claiming to be “support” in chat.',
  },
  {
    q: 'What types of games are available on PNGGO?',
    a: 'PNGGO keeps things clear for Papua New Guinea players: a strong slots library, real-dealer live tables, and a full sportsbook — everything under one secure login so you can play the way you prefer.',
  },
  {
    q: 'What payment methods does PNGGO accept?',
    a: 'Deposit and withdraw in Papua New Guinea Kina (PGK) through PNGGO’s banking partners — Kina Bank and BSP — using online banking, mobile apps, and other supported flows shown at checkout. For step-by-step guides, limits, and cut-off times, open the Payment page on this site before you transfer.',
  },
  {
    q: 'Are there any bonuses or promotions for new users?',
    a: 'Yes. New members can claim welcome offers and seasonal promos — amounts and turnover rules vary by campaign. Open the Promotions area after sign-up to see what is live today and opt in before you play.',
  },
  {
    q: 'Is PNGGO legal and licensed?',
    a: 'PNGGO operates as a licensed platform in Papua New Guinea. That framework is there to protect players: regulated standards, safer play, and a clear place to turn if something does not look right.',
  },
  {
    q: 'Are there any restrictions on who can use PNGGO?',
    a: 'You must be 21 or older and legally allowed to gamble in Papua New Guinea. Self-excluded players, sanctioned individuals, and anyone barred under our terms cannot use the service — we enforce this to keep the community fair.',
  },
  {
    q: 'What measures does PNGGO take to ensure fair gaming?',
    a: 'We work with regulated, audited game suppliers; use secure, logged transactions; and apply house rules transparently. If you ever dispute a result, contact support with your bet ID — we investigate and explain outcomes in line with provider rules.',
  },
];

function FAQItem({ q, a }: { q: string; a: string }) {
  const [open, setOpen] = useState(false);
  return (
    <div className="border-b border-white/10">
      <button
        className="w-full flex items-center justify-between py-4 text-left cursor-pointer group"
        onClick={() => setOpen(!open)}
      >
        <span className="text-white/85 text-sm font-medium group-hover:text-[#B80E28] transition-colors pr-4">{q}</span>
        <span className="w-6 h-6 flex items-center justify-center flex-shrink-0 text-[#B80E28]">
          <i className={`fas ${open ? 'fa-minus' : 'fa-plus'} text-xs`}></i>
        </span>
      </button>
      {open && (
        <div className="pb-4 text-white/55 text-sm leading-6">{a}</div>
      )}
    </div>
  );
}

export default function MissionFAQSection() {
  return (
    <section className="bg-[#111] py-16">
      <div className="max-w-7xl mx-auto px-6">
        {/* Mission & Vision */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 mb-16">
          <div className="bg-[#1a1a1a] rounded-xl p-8 border border-white/5">
            <h2 className="text-white text-2xl font-bold mb-4 flex items-center gap-3">
              <span className="w-1 h-6 bg-[#B80E28] rounded-full inline-block"></span>
              Our Mission
            </h2>
            <p className="text-white/60 text-sm leading-7">
              PNGGO exists to give Papua New Guinea a gaming home they can trust: honest information, secure accounts, and tools that help you stay in control. Every day we focus on safer play, clear rules, fast support in PGK, and zero tolerance for shortcuts that put players at risk. Our mission is not just to entertain — it is to earn your confidence, one fair outcome and one straight answer at a time.
            </p>
          </div>
          <div className="bg-[#1a1a1a] rounded-xl p-8 border border-white/5">
            <h2 className="text-white text-2xl font-bold mb-4 flex items-center gap-3">
              <span className="w-1 h-6 bg-[#B80E28] rounded-full inline-block"></span>
              Our Vision
            </h2>
            <p className="text-white/60 text-sm leading-7">
              We aim to be Papua New Guinea&apos;s first choice — the name players recommend because the product feels local, the technology keeps pace, and the experience still feels human. Looking ahead, PNGGO will keep investing in smoother mobile play, smarter payments, and richer entertainment — always grounded in PNG values of community, respect, and straight talk. That is the future we are building toward.
            </p>
          </div>
        </div>

        {/* FAQ */}
        <div className="max-w-3xl mx-auto">
          <h2 className="text-white text-3xl font-bold text-center mb-10">FREQUENTLY ASKED QUESTIONS</h2>
          <div className="bg-[#1a1a1a] rounded-xl px-6 border border-white/5">
            {faqs.map((faq, i) => (
              <FAQItem key={i} q={faq.q} a={faq.a} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
